import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { actions } from "../../../../redux/store/store";

const EditDriverLicense = (props) => {
  const state = props?.state
  const title = props?.title
  const id = props && props?.id && props?.id;
  const role = props && props.currentUser && props?.currentUser?.role;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <span>{props?.birthday}</span>
        {role === "root" &&
          <span
            style={{ cursor: "pointer" }}
            onClick={() =>
              actions.modal.openDriverLicense({
                id,
                title,
                state,
                ...props?.driverData
              })
            }
          >
            <EditIcon style={{ width: "20px", height: "20px" }} />
          </span>
        }
    </div>
  );
};

export default EditDriverLicense;
